/**
 *  订阅公用
 */

import { mapState, mapGetters, mapActions } from "vuex"
import { checkSessionType } from "@api/user"

export default {
  name: "SubscribeItem",
  computed: {
    ...mapState({
      subscribeGroups: state => state.subscribeGroups
    }),
    ...mapGetters(["sessionObj"])
  },
  created() {
    if (checkSessionType({ sessionObj: this.sessionObj }) == "third") return

    // 请求订阅信息
    // fix by sevencai 20201010 没 catch 造成 uncaught promise
    this.getUserSubscribe({})
      .then(info => {
        if (info && info.subscribe_groups) this.setSubscribeGroups(info.subscribe_groups)
      })
      .catch(() => {})
  },
  methods: {
    ...mapActions(["getUserSubscribe", "setSubscribeGroups"]),
    changeSubscribePromp({ promptStatus, subscribeId = "", groupId = "" }) {
      this.$refs.subscribePromptRef.changePromptConfirmSubscribe({ promptStatus, subscribeId, groupId })
    }
  }
}
